<template>
  <div class="manual_installation">
    <header-component
      :is-soon="false"
      :backRoute="true"
      :progression="false"
      img-left="/trocachip/img/setinha-left-preto.svg"
      img-right="/trocachip/img/access.png"
      class="header-component"
    />
    <div class="manual_installation-img">
      <img src="@/assets/images/Render-icon.svg" alt="TIM eSIM" />
    </div>
    <div class="manual_installation_title">
      <span v-html="pageInfo.title"></span>
    </div>
    <div class="installation_instructions">
      <span class="installation_instructions_span">{{ pageInfo.sub_title }}</span>
    </div>
    <section class="device_selection_container">
    <div class="selection_container">
          <div class="selection_input" @click="toggleBrandSelectionOpened">
            <span
              v-html="selectedBrandName()"/>
          </div> 
        </div>
        <div
            class="selection_options_container"
            :class="{ opened_options: brandSelectionOpened }"
          >
            <label
              id="device_mark"
              v-for="(item, index) in brandsList"
              :key="index"
              v-html="item"
              :value="item"
              @click="() => selectBrand(item)"
            />
          </div>
      </section>
    <section class="instructions_list">

      <li v-for="(step, index) in steps" :key="index" class="border_bottom">
        <div class="instruction_item">
          <div class="instruction_text">
            <div class="instruction_image_container">
            <img :src="getImageSrc(step.image)" alt="" class="instruction_image" />
          </div>
            <div class="instruction_text_container">
            <div class="text_subtitle">
            <span class="main_text">{{ step.main }}</span>
            <span v-if="step.subtitle" class="instructions_subtitle">{{ step.subtitle }}</span>
            </div>
          </div>
         
          </div>
          <div v-if="step.activationCodes" class="copy_area"> 
              <li v-for="(code, index) in step.activationCodes" :key="index">
                <div class="copy_block">
                <div class="activation_code_title">
                  <span>{{ code.title }}</span>
                </div>
                <div class="activation_code_block">
                  <span class="protocol_code">{{ correctValue(2 - index) }}</span>
                  <div class="copy_button">
                    
                  <button 
                    class="copy_button_button"
                    v-clipboard:copy="correctValue(2 - index)"
                    v-clipboard:success="() => onCopy(code, 'copiar')"
                    v-clipboard:error="onError"
                  >
                    <img :src="getImageSrc(code.button_img)" alt="" class="instruction_image" />
                    <span class="button_text">{{ code.button_name }}</span>
                    </button>
                  </div>
                </div>
              </div>
              </li>
          </div>
        </div>
      </li>
    </section>
    <section class="installation_tutorial_info_card">
      <div class="tutorial_content">
        <div class="text_content" :class="{ 'use-max-width': useMaxWidth }">
          <p v-html="pageInfo.footer_title" class="installation_title"></p>
          <p v-html="pageInfo.footer_subtitle" class="footer_subtitle"></p>
          <a
            href="#"
            @click.prevent="viewQRCode(pageInfo.footer_link)"
            class="QRCode_install_link">
            {{ pageInfo.footer_button }}
          </a>
        </div>        
      </div>
      <div class="footer_image">
        <div class="icon_box">
        <img :src="getImageSrc(pageInfo.footer_icon)" alt="" class="footer_icon"/>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import { mapState } from "vuex";
import HeaderComponent from "@/components/HeaderComponent.vue";
import trackEvent from "@/services/trackEvent";

export default {
  name: "ManualInstallation",
  components: { HeaderComponent},
  created() {
    this.sendTracker("passo_a_passo_manual", 6, 3)
    this.brandsList = this.pageInfo.steps.map(step => {
      return step.brandName;
    })
    this.steps = this.pageInfo.steps.find(
        (deviceElement) => {
          return deviceElement.brand == this.selectedBrand;
        }
      ).stepList
  },
  computed: {
    ...mapState({
      ac: (state) => state.ac,
      config: (state) => state.config,
      customer: (state) => state.customer,
      pageInfo: (state) => state.config.manual_installation,
      selectedBrand: (state) => state.selectedBrand,
      urlEsim: (state) => state.urlEsim,
      useMaxWidth: (state) => state.config.manual_installation.useMaxWidth,

    }),
  },
  data() {
    return {
      brandsList: "",
      steps: [],
      brandSelectionOpened: false
    }
  },
  watch: {
    selectedBrand() {
      this.getStepsByselectedBrand();
    },
  },
  methods: {
    sendTracker(eventLabel, eventCategory = 6, eventAction = 2) {
      trackEvent.track({
        user: {
          login: this.customer.login,
          loginType: this.customer.loginType,
          lineType: this.customer.lineType,
          segment: this.customer.segment,
          subSegment: this.customer.subSegment,
          planCode: this.customer.planCode,
          planName: this.customer.planName,
        },
        channel: trackEvent.getChannel(),
        "event-category": eventCategory,
        "event-label": eventLabel,
        "event-location": "null",
        "event-value": this.customer.isExOiCustomer ? "oi" : "tim",
        "event-status": "Sucesso",
        "event-action": eventAction,
      });
    },
    getImageSrc(imageName) {
      return require("@/assets/images/" + imageName);
    },
    getStepsByselectedBrand() {
      const deviceListConfig = this.pageInfo.steps.find(
        (deviceElement) => {
          return deviceElement.brand == this.selectedBrand;
        }
      );
      console.log(deviceListConfig)
      if (this.selectedBrand == "Apple") {
        this.$store.dispatch("selectedBrand", "Apple");
      } else if (this.selectedBrand == "Motorola") {
        this.$store.dispatch("selectedBrand", "Motorola");
      } else if (this.selectedBrand == "Samsung") {
        this.$store.dispatch("selectedBrand", "Samsung");
      } else {
        this.$store.dispatch("selectedBrand", "Android");
      }
      if (deviceListConfig !== undefined) {
        this.steps = deviceListConfig.stepList;
      } else {
        this.steps = this.pageInfo.steps.find(
        (deviceElement) => {
          return deviceElement.brand == "Outras marcas";
        })
      }
    },
    selectBrand(value) {
      const deviceListConfig = this.pageInfo.steps.find(
        (deviceElement) => {
          return deviceElement.brandName == value;
        })
      console.log("selected Brand: "+value+ " resulting in: "+deviceListConfig.brand);
      this.$store.dispatch("selectedBrand",  deviceListConfig.brand);
      this.brandSelectionOpened = false;
    },
    selectedBrandName() {
      const deviceListConfig = this.pageInfo.steps.find(
        (deviceElement) => {
          return deviceElement.brand == this.selectedBrand;
        }
      );
      return deviceListConfig.brandName;
    },
    toggleBrandSelectionOpened() {
      this.brandSelectionOpened = !this.brandSelectionOpened;
    },
    correctValue(value) {
      let currentStep = this.pageInfo.steps.find(
        (deviceElement) => {
          return deviceElement.brand == this.selectedBrand;
        }
      )
      if (currentStep.isSplit) {
      const str = this.urlEsim;
      const urlEsim = str.split("$");
      return urlEsim[value];
      } else {
        return this.urlEsim;
      }
    },
    viewQRCode(link) {
      this.sendTracker("manual_instalacao_qr_code");
      if (link) {
        this.$router.push({ name: link });
      }
    },
    onCopy(code, buttonName) {
      let trackerValue = null;
      
      if (buttonName === "copiar") {
        trackerValue = code.tracker_copy || code.tracker_address;
      }

      if (trackerValue && typeof trackerValue === 'string') {
        this.sendTracker(`passo_a_passo_copiar_${trackerValue}`);
        console.log(`Texto copiado com sucesso pelo botão: ${buttonName}, Tracker: ${trackerValue}`);
      } else {
        console.log("Erro: trackerValue não encontrado ou não é uma string.");
      }
    },

    onError() {
      console.error("Não foi copiado com sucesso.");
    },    
  }
};
</script>

<style lang="scss" scoped>
  .manual_installation {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  z-index: -1;
  > .page_content {
    margin: 25% 0%;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  .device_selection_container {
      
      margin-top: 2.125rem;
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;
      >.selection_options_container {
          display: none;
        }
        > .selection_options_container.opened_options {
          position: relative;
          display: flex;
          width: 328px;
          max-height: 200px;
          overflow-y: scroll;
          overflow-x: hidden;
          flex-direction: column;
          background: #fff;
          border-radius: 16px;
          box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.15);
          z-index: 10;
          > label {
            width: 100%;
            padding: 24px 0 0 24px;
            font-family: "timsans_regular";
            font-size: 0.875rem;
            color: #9c9c9c;
            line-height: 21px;
            cursor: pointer;
          }
          > label:last-child {
            padding-bottom: 24px;
          }
          > label:hover {
            background-color: #e7e7e7;
          }
        }
      > .selection_container {
        position: relative;
        > .selection_input {
          width: 100%;
          height: 40px;
          padding: 0px 16px;
          border-radius: 24px;
          color: #000000;
          font-family: "timsans_regular";
          font-size: 14px;
          -webkit-appearance: none;
          -moz-appearance: none;
          overflow: auto;
          border: 1px solid #000000;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          cursor: pointer;
        }
        > .selection_input::-ms-expand {
          display: none;
        }
        > .selection_input::after {
          content: "<";
          font: 10px "Consolas", monospace;
          color: #000000;
          -webkit-transform: rotate(180deg) scaleY(1.2);
          -moz-transform: rotate(270deg) scaleY(1.2);
          -ms-transform: rotate(270deg) scaleY(1.2);
          transform: rotate(270deg) scaleY(1.2);
          position: relative;
          pointer-events: none;
          left: 5px;
          width: 10px;
          margin-bottom: 5px;
        }
      }
      > .confirmation_container {
        display: flex;
        flex-direction: row;
        margin: 0px 8px;
        > input {
          width: 52px !important;
          height: 24px !important;
          -webkit-appearance: none;
          border: 1px solid #9c9c9c;
          background: #ffffff;
          color: #ffffff;
          text-align: center;
          border-radius: 8px;
          margin: 0 !important;
          background-position: center;
        }
        > input:checked {
          background-image: url("../../assets/images/on-filled.svg");
          -webkit-appearance: none;
          border-color: transparent;
        }
        > p {
          margin-block: 0 !important;
          margin-left: 0.5rem;
          font-family: "timsans_regular";
          font-size: 0.875rem;
          color: #9c9c9c;
        }
      }
    }
  .manual_installation-img{
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 85px;
}
  .manual_installation_title {
    font-weight: 300;
    font-size: 27px;
    line-height: 30px;
    align-items: center;
    display: flex;
    font-family: "timsans_regular";
    width: 280px;
    text-align: center;
    flex-direction: column;
    margin: auto;
    margin-top: 1rem;
  }
  .installation_instructions {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: "timsans_regular";
    font-size: 16px;
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    margin-top: 1rem;
    color: #696969;
    width: 325px;
    margin: auto;
  }
  .installation_instructions_span {
    margin-top: 1rem;
  }
  .instruction_item {
    width: 100%;

    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 2rem 0px;
  }

  .border_bottom {
    border-bottom: 1px solid #e5e5e5;
    border-width: 1.5px;
    width: 100%;
  }
  .instructions_list {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .instruction_text {
    display: flex;
    flex-direction: row;
  }

  .instruction_image_container {
    height: 64px !important; 
    width: 64px !important; 
    display: flex;
    align-items: center;
  }


  .instructions_list {
    list-style: none;
    padding: 0;
    li {
      font-size: 14px;
      line-height: 1.5;
      display: flex;
      align-items: flex-start;

      span {
        display: inline-block;
      }
    }
  }
  .instruction_text_container {
    display: flex;
    width: 280px;
    min-height: 64px;
    align-items: center;
    justify-items: center;
  }

  .instructions_subtitle {
    font-family: "timsans_regular";
    color: #696969;
    font-weight: 400;
    font-size: 14px;
  }

  .main_text {
    font-family: "timsans_bold";
    font-size: 14px;
    font-weight: 500;
    width: 280px;
  }

  .installation_tutorial_info_card {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: 1.5rem;
    border-top: 2px solid #d9d9d9;    

    .tutorial_content {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
    }

    .text_content {
      flex: 1;
      display: flex;
      flex-direction: column;
      width: 255px;
      &.use-max-width {
        max-width: 255px;
      }

      .installation_title {
        font-family: "timsans_regular";
        font-size: 14px;
        line-height: 21px;
        color: #000000;
        margin-bottom: 8px;
        font-weight: bold;
      }
      
      .footer_subtitle {
        font-family: "timsans_regular";
        font-size: 14px;
        color: #696969;
        line-height: 21px;
      }

      .QRCode_install_link {
        font-family: "timsans_regular";
        font-size: 16px;
        font-weight: bold;
        color: #0026D9;
        text-decoration: none;
      }
    }
    .footer_image {
      margin-top: 40px;
      margin-left: 24px
    }

    .icon_box {
      width: 48px;
      height: 48px;
      border-radius: 16px;
      border: 1px solid #e5e5e5;
      display: flex;
    }

    .footer_icon {
      margin: auto;
    }
  }
  .copy_area {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    width: 100%;
  }
  .activation_code_title {
    font-family: "timsans_regular";
    font-size: 14px;
    font-weight: 400;
    color:#696969;
    text-align: center;
    margin-bottom: 0.5rem;
    margin-top: 24px;
  }

  .activation_code_block {
    border-radius: 7.49px;
    border: 1px dashed #bababa;
    border-width: 1.5px;
    width: 328px;
    height: 118px;
    margin: auto;
    align-items: center;
    display: flex;
    flex-direction: column;
  }
  .protocol_code {
    font-family: "timsans_regular";
    font-weight: 400;
    font-size: 14px;
    margin-top: 1.25rem;
    text-align: center;
  }

  .copy_button {
    margin-top: 1.5rem;
  }
  .copy_button_button {
    display: flex;
    flex-direction: row;
    align-items: center;
    background: #ffffff;
    border: 0px;
    color: #0026D9;
    font-family: "timsans_bold";
    font-weight: 400;
    font-size: 16px;
  }
}

</style>